{
  "languages": {
    "en": "English",
    "es": "Español",
    "it": "Italiano"
  },
  "labels": {
    "language": "Lingua",
    "source": "Fonte",
    "license": "Licenza",
    "format": "Formato",
    "keywords": "Parole chiave",
    "relevance": "Rilevanza",
    "relevanceLevels": {
      "low": "Bassa",
      "medium": "Media",
      "high": "Alta"
    },
    "size": "Dimensione",
    "all": "Tutti",
    "description": "Descrizione",
    "cancel": "Annulla",
    "saved": "Salvati",
    "page": "Pagina",
    "of": "di",
    "save": "Salva",
    "download": "Scarica",
    "details": "Dettagli",
    "add": "Aggiungi",
    "datasource": "Datasource",
    "datasource-name": "Nome datasource",
    "file-name": "Nome file",
    "file-url": "URL file",
    "column-count": "Numero colonne",
    "row-count": "Numero righe",
    "columns": "Colonne",
    "column-name": "Nome colonna",
    "column-type": "Tipo colonna",
    "errors": "Errori",
    "no-errors": "Nessun errore",
    "created-at": "Creato il",
    "updated-at": "Aggiornato il"
  },
  "strings": {
    "data-discovery": "Data Discovery",
    "deep-search": "Ricerca approfondita",
    "add-keywords": "Aggiungi parole chiave",
    "available-files": "File disponibili",
    "relevance-score": "Punteggio di rilevanza",
    "relevance-chip-tooltip": "Rilevanza: {value}",
    "min-relevance": "Rilevanza minima",
    "max-relevance": "Rilevanza massima",
    "min-size": "Dimensione minima",
    "max-size": "Dimensione massima",
    "size-hint": "Dimensione in KB (filtra i singoli file)",
    "saved-datasets": "Dataset Salvati",
    "search-data-sources": "Ricerca fonti dati",
    "deep-search-hint": "Una ricerca approfondita ti darà molti più risultati",
    "search-completed": "Ricerca completata",
    "results-found": "risultati trovati",
    "no-search-performed": "Inizia a cercare dataset utilizzando il modulo di ricerca sopra",
    "no-results-found": "Nessun risultato trovato. Prova a modificare la query di ricerca o i filtri.",
    "no-files-available": "Nessun file disponibile per questo dataset",
    "relevance-hint": "Una coppia di valori compresi tra 0 e 10",
    "relevance-hint-categorical": "Una coppia di valori tra i livelli di rilevanza configurati",
    "download-cors-error": "Download diretto non disponibile per file esterni.",
    "download-fallback": "Il file è stato gestito dal browser (aperto o scaricato).",
    "download-open-failed": "Impossibile aprire il file in una nuova scheda.",
    "download-invalid-url": "URL del file non valido.",
    "add-endpoint": "Aggiungi Endpoint",
    "add-to-new-datasource": "Aggiungi a un nuovo datasource",
    "add-to-existing-datasource": "Aggiungi a un datasource esistente",
    "no-datasources-available": "Nessun datasource disponibile.",
    "no-file-selected": "Nessun file selezionato.",
    "value-required": "Valore richiesto.",
    "no-details-available": "Dettagli non disponibili per questo file.",
    "details-failed": "Impossibile caricare i dettagli. Riprova.",
    "no-saved-datasets": "Nessun dataset salvato",
    "save-datasets-hint": "Clicca sull'icona bookmark su qualsiasi dataset per salvarlo temporaneamente durante questa sessione di ricerca",
    "datasets-saved": "dataset salvati",
    "confirm-clear-all": "Rimuovere tutti i dataset salvati?",
    "confirm-clear-all-message": "Sei sicuro di voler rimuovere tutti i dataset salvati? Questa azione non può essere annullata.",
    "view-dataset": "Visualizza Dataset",
    "show-details": "Mostra dettagli",
    "hide-details": "Nascondi dettagli",
    "clear-filters": "Rimuovi Filtri",
    "back-to-search": "Torna alla Ricerca",
    "clear-all": "Rimuovi Tutto",
    "datasource-name-hint": "Scrivi un nome per la tua sorgente dati",
    "datasource-project-description": "Scrivi una breve descrizione dell'origine dati",
    "redirect-warning": "Procedendo verrai reindirizzato alla sezione Datasources e la ricerca verrà azzerata. Se preferisci restare qui, la creazione continuerà in background.",
    "redirect-choice": "Reindirizzami ai Datasources dopo la creazione",
    "datasource-created-success": "Datasource creato con successo!",
    "dataset-added-success": "Dataset aggiunto con successo!",
    "datasource-and-dataset-created-success": "Datasource e dataset creati con successo!"
  }
}
